import { StringKey } from '../../lang/index';
import { FilterVariant, StakeholderFilter } from '../../types/stakeholder.types';

export enum StakeholderCard {
  STAKEHOLDERS = 'stakeholders',
  TERMINATED = 'terminated',
}

export const stakeholderCardTranslation: Record<
  StakeholderCard,
  Record<FilterVariant, StringKey>
> = {
  [StakeholderCard.STAKEHOLDERS]: {
    [StakeholderFilter.ACTIVE]: 'ACTIVE_STAKEHOLDERS',
    [StakeholderFilter.INACTIVE]: 'INACTIVE_STAKEHOLDERS',
    all: 'ALL_STAKEHOLDERS',
  },
  [StakeholderCard.TERMINATED]: {
    all: 'ALL_TERMINATED',
    [StakeholderFilter.ACTIVE]: 'ACTIVE_TERMINATED',
    [StakeholderFilter.INACTIVE]: 'INACTIVE_TERMINATED',
  },
};
export const stakeholderCardTabMap: Record<StakeholderCard, StringKey> = {
  [StakeholderCard.STAKEHOLDERS]: 'STAKEHOLDERS_TAB',
  [StakeholderCard.TERMINATED]: 'TERMINATED_TAB',
};

export const arrayOfStakeholderCardTab = Object.entries(stakeholderCardTabMap);
